module.exports = __webpack_public_path__ + "static/img/usinessPartner_05.59563f3e.jpg";